export default "dist/images/components-design-separator-control-wave-3.9e204d5.png";